import { combineReducers } from "redux";
import recoverPassword from "../modules/recoverPassword/reducer";
import confirmToken from "../modules/confirmToken/reducer";
import billingPlan from "../modules/billingPlan/reducer";
import sessionStorage from "../modules/sessionStorage/reducer";
import register from "../modules/register/reducer";
import qrCode from "../modules/qrCode/reducer";
import token from "../modules/token/reducer";
import auth from "../modules/auth/reducer";
import analytics from "../modules/analytics/reducer";
import onboardSimple from "./onboardSimple/reducer";

export default combineReducers({
	recoverPassword,
	confirmToken,
	sessionStorage,
	billingPlan,
	onboardSimple,
	register,
	qrCode,
	token,
	auth,
	analytics,
});
